import React from "react";
import { translations } from "../../translations";
import { formatTimeTaken } from "../../utils/quiz";

const QuizHeader = ({ current, total, elapsedSeconds, lang }) => {
  const t = translations[lang];
  const progress = total > 0 ? ((current + 1) / total) * 100 : 0;

  return (
    <header className="quiz-header">
      <div className="quiz-header-inner">
        <div className="quiz-header-brand">
          <img src="/logo.png" alt="" className="quiz-header-logo" />
          <span className="quiz-badge">{t.questionProgress} {current + 1}/{total}</span>
        </div>
        <div className="quiz-timer">
          <span className="quiz-timer-dot" />
          {formatTimeTaken(elapsedSeconds)}
        </div>
      </div>
      <div className="quiz-progress-track">
        <div className="quiz-progress-fill" style={{ width: `${progress}%` }} />
      </div>
    </header>
  );
};

export default QuizHeader;
